import YEmptyState from './EmptyState';

export { YEmptyState };
export default YEmptyState;
